import { colors } from "@elit-hair/elit-tools";
import { IconButton } from "@mui/material";
import { DateTime } from "luxon";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { TbPrinter } from "react-icons/tb";
import QRCode from "react-qr-code";

import PlateComponent from "@/components/Plate";

export const QRCodeDialog = ({
    driverId,
    vehicleId,
    plate,
}: {
    vehicleId: string;
    plate: string;
    driverId: string;
}) => {
    const { t } = useTranslation();

    const qrCodeValue = useMemo(() => {
        return `https://transport.elitklinik.io/qr?vehicleId=${vehicleId}&date=${DateTime.now().toFormat("yyyy-MM-dd")}`;
    }, [driverId]);

    return (
        <>
            <div className="flex flex-col gap-2 p-4 mb-8 print:hidden">
                <div className="flex justify-between items-center mx-4">
                    <h3 className="text-lg text-elitDarkBlue font-bold mb-0 mt-0 flex gap-2 items-center justify-between w-full">
                        {t("qr_code")}
                    </h3>
                    <IconButton onClick={() => window.print()}>
                        <TbPrinter className="text-3xl text-elitDarkBlue" />
                    </IconButton>
                </div>

                <div className="flex flex-col items-center justify-center gap-4 bg-white">
                    <div className="rounded-lg p-4 bg-white">
                        <QRCode value={qrCodeValue} fgColor={colors.elitDarkBlue} className="h-full w-full" />
                    </div>
                    <PlateComponent plate={plate} />
                </div>
            </div>

            {/* Print-only layout: invisible on screen, shown by the browser only while rendering the print output */}
            <div className="hidden print:flex fixed inset-0 flex-col items-center justify-center gap-4 bg-white">
                <div className="rounded-lg p-2 w-[92vmin] h-[92vmin] bg-white">
                    <QRCode value={qrCodeValue} fgColor={colors.elitDarkBlue} className="h-full w-full" />
                </div>
                <PlateComponent plate={plate} className="scale-[2]" />
            </div>
        </>
    );
};
